module.exports = __webpack_public_path__ + "media/public/img/landing_page/GettinLocal-4-a5f10da14bba674cf5ca44442500df18.png";